import script from "./ButtonMoreWords.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonMoreWords.vue?vue&type=script&setup=true&lang=js"

import "./ButtonMoreWords.vue?vue&type=style&index=0&id=d3d11c78&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3d11c78"]])

export default __exports__